"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENotificationTemplateNames = exports.ENotificationTypes = exports.EReadStatus = exports.ENotificationChannel = void 0;
var ENotificationChannel;
(function (ENotificationChannel) {
    ENotificationChannel["Email"] = "EMAIL";
    ENotificationChannel["SMS"] = "SMS";
    ENotificationChannel["PushNotification"] = "PUSH_NOTIFICATION";
    ENotificationChannel["WhatsApp"] = "WHATSAPP";
})(ENotificationChannel || (exports.ENotificationChannel = ENotificationChannel = {}));
var EReadStatus;
(function (EReadStatus) {
    EReadStatus["NeverRead"] = "NEVER_READ";
    EReadStatus["PartiallyRead"] = "PARTIALLY_READ";
    EReadStatus["FullyRead"] = "FULLY_READ";
})(EReadStatus || (exports.EReadStatus = EReadStatus = {}));
var ENotificationTypes;
(function (ENotificationTypes) {
    ENotificationTypes["NewOrder"] = "NEW_ORDER";
    ENotificationTypes["AccountValidation"] = "ACCOUNT_VALIDATION";
    ENotificationTypes["PasswordForgot"] = "PASSWORD_FORGOT";
    ENotificationTypes["OrderStatusUpdate"] = "ORDER_STATUS_UPDATE";
    ENotificationTypes["ChannelImportSuccess"] = "CHANNEL_IMPORT_SUCCESS";
    ENotificationTypes["ChannelImportFail"] = "CHANNEL_IMPORT_FAIL";
    ENotificationTypes["PublishedProduct"] = "PUBLISHED_PRODUCT";
    ENotificationTypes["UnpublishedProduct"] = "UNPUBLISHED_PRODUCT";
    ENotificationTypes["ChannelConnectionFail"] = "CHANNEL_CONNECTION_FAIL";
    ENotificationTypes["ChannelConnectionSuccess"] = "CHANNEL_CONNECTION_SUCCESS";
    ENotificationTypes["RequestSaleApproval"] = "REQUEST_SALE_APPROVAL";
    ENotificationTypes["RequestSaleDisapproval"] = "REQUEST_SALE_DISAPPROVAL";
    ENotificationTypes["VerifyEmail"] = "VERIFY_EMAIL";
    ENotificationTypes["Unsubscribe"] = "UNSUBSCRIBE";
    ENotificationTypes["AccountValidationToResetPassword"] = "ACCOUNT_VALIDATION_TO_RESET_PASSWORD";
    ENotificationTypes["StorefrontOrderStatus"] = "STOREFRONT_ORDER_STATUS";
    ENotificationTypes["StorefrontOrderCreated"] = "STOREFRONT_ORDER_CREATED";
    ENotificationTypes["StorefrontRedirectWhatsappMessage"] = "STOREFRONT_REDIRECT_WHATSAPP_MESSAGE";
    ENotificationTypes["TrialExpired"] = "TRIAL_EXPIRED";
    ENotificationTypes["TrialExpireIn8Days"] = "TRIAL_LAST_8_DAYS";
    ENotificationTypes["TrialExpireIn3Days"] = "TRIAL_LAST_3_DAYS";
    ENotificationTypes["FreemiumDay7"] = "FREEMIUM_DAY_7";
    ENotificationTypes["FreemiumDay6"] = "FREEMIUM_DAY_6";
    ENotificationTypes["TrialExpiredLastOffer"] = "PURCHASE_LAST_OFFER";
    ENotificationTypes["ContractPixUpdated"] = "CONTRACT_PIX_UPDATED";
    ENotificationTypes["AccountCancelation"] = "ACCOUNT_CANCELED";
    ENotificationTypes["StoreReferral"] = "STORE_REFERRAL";
    ENotificationTypes["DomainConnectionSuccess"] = "DOMAIN_CONNECTION_SUCCESS";
    ENotificationTypes["DomainConnectionFailure"] = "DOMAIN_CONNECTION_FAILURE";
})(ENotificationTypes || (exports.ENotificationTypes = ENotificationTypes = {}));
var ENotificationTemplateNames;
(function (ENotificationTemplateNames) {
    ENotificationTemplateNames["AccountValidation"] = "account_validation";
    ENotificationTemplateNames["ForgotPasswordCode"] = "forgot_password-code";
    ENotificationTemplateNames["ForgotPasswordSuccess"] = "forgot_password-success";
    ENotificationTemplateNames["NewMessage"] = "new_message";
    ENotificationTemplateNames["ChannelConnectionSuccess"] = "channel_connection-success";
    ENotificationTemplateNames["ChannelConnectionFail"] = "channel_connection-fail";
    ENotificationTemplateNames["ChannelImportSuccess"] = "channel_import-success";
    ENotificationTemplateNames["ChannelImportFail"] = "channel_import-fail";
    ENotificationTemplateNames["NewOrder"] = "new_order";
    ENotificationTemplateNames["UpdateOrderStatus"] = "update_order_status";
    ENotificationTemplateNames["Channel"] = "channel-disconnected";
    ENotificationTemplateNames["Email"] = "email-updated";
    ENotificationTemplateNames["Invitation"] = "invitation";
    ENotificationTemplateNames["PublishedProduct"] = "published-product";
    ENotificationTemplateNames["UnpublishedProduct"] = "unpublished-product";
    ENotificationTemplateNames["RequestSaleApproval"] = "request-sale-approval";
    ENotificationTemplateNames["RequestSaleDisapproval"] = "request-sale-disapproval";
    ENotificationTemplateNames["Welcome"] = "welcome";
    ENotificationTemplateNames["Unsubscribe"] = "unsubscribe";
    ENotificationTemplateNames["AccountValidationToResetPassword"] = "confirm-account-to-reset-pw";
    ENotificationTemplateNames["NewOrderV2"] = "new_order_v2";
    ENotificationTemplateNames["TrialExpired"] = "trial_expired";
    ENotificationTemplateNames["TrialExpireIn8Days"] = "trial_last_8_days";
    ENotificationTemplateNames["TrialExpireIn3Days"] = "trial_last_3_days";
    ENotificationTemplateNames["FreemiumDay6"] = "v4_6";
    ENotificationTemplateNames["FreemiumDay7"] = "v4_7";
    ENotificationTemplateNames["TrialExpiredLastOffer"] = "purchase_last_offer";
    ENotificationTemplateNames["SubscriptionInvoicePix"] = "subscription-invoice-pix";
    ENotificationTemplateNames["AccountCancelation"] = "account_cancelation";
    ENotificationTemplateNames["StoreReferral"] = "referral";
    ENotificationTemplateNames["DomainConnectionSuccess"] = "domain_connection_success";
    ENotificationTemplateNames["DomainConnectionFailure"] = "domain_connection_failure";
})(ENotificationTemplateNames || (exports.ENotificationTemplateNames = ENotificationTemplateNames = {}));
//# sourceMappingURL=notification.js.map